import React, { memo } from 'react'
import type { PLLHit } from '../types'
import {
  ResultRow,
  ResultAvatar,
  ResultInfo,
  ResultName,
  ResultMeta,
  ResultChevron,
} from '../styles'
import { HighlightedText } from './HighlightedText'

type PlayerResultItemProps = {
  item: PLLHit
  query: string
  onSelect: () => void
}

export const PlayerResultItem = memo<PlayerResultItemProps>(
  ({ item, query, onSelect }) => {
    const handleKeyDown = (e: React.KeyboardEvent): void => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onSelect()
      }
    }

    return (
      <ResultRow
        role="option"
        tabIndex={0}
        onClick={onSelect}
        onKeyDown={handleKeyDown}
        aria-label={`${item.title}${item.position ? `, ${item.position}` : ''}`}
      >
        {item.image && <ResultAvatar src={item.image} alt="Result profile" loading="lazy" />}
        <ResultInfo>
          <ResultName>
            <HighlightedText text={item.title || ''} query={query} />
          </ResultName>
          {item.teamName && <ResultMeta>{item.teamName}</ResultMeta>}
        </ResultInfo>
        <ResultChevron aria-hidden="true">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M9 18l6-6-6-6" />
          </svg>
        </ResultChevron>
      </ResultRow>
    )
  }
)

PlayerResultItem.displayName = 'PlayerResultItem'
